module.exports = __webpack_public_path__ + "static/media/infographie-mocktails-mini.91a2a492.png";